import { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";

export function useSession() {
    const [session, setSession] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;

        const apply = (nextSession) => {
            if (!mounted) return;
            setSession(nextSession || null);
            setLoading(false);
        };

        supabase.auth.getSession().then(({ data }) => {
            apply(data.session);
        });

        const { data: sub } = supabase.auth.onAuthStateChange(
            (_event, nextSession) => {
                apply(nextSession);
            },
        );

        return () => {
            mounted = false;
            sub.subscription.unsubscribe();
        };
    }, []);

    return { session, loading };
}
